import React from 'react';
import { baseCss } from '../css';

const Checkbox = ({ active, onClick }) => (
    <div
        className={`checkbox ${active ? 'active' : ''}`} style={{ ...baseCss.primaryBorder, ...(active && baseCss.primaryBackground) }}
        onClick={onClick}
    >
        <div></div>
    </div>
)

export default Checkbox